import axios from 'axios';
import React,{Component} from 'react'
import Header from '../common/checkHeader.jsx';
import Footer from '../common/checkFooter.jsx';
import QRCode  from 'qrcode.react';
import {getCookie,requestMainUrl} from '../../common/service/common'
import { messageTips } from '../../common/service/Tools.jsx';
// import {config} from '../../common/service/http'
// import CountDown from '../../expertonline/components/CountDown'
var timer;
var setWechatTimer;
var setTimer;
var setloadTimer;
var sid = getCookie('z_sid');
export default class CheckDetail extends Component{
    constructor(){
        super();
        this.state={
            paperCheckInfo:{},
            minute:29,
            seconds: 59,
            orderNO:'',
            serId:'',
            chartQRCodeLink:'',
            payOrderTimeFlag:false,
            payProblemFlag:false,
            payOrderMoneyFlag:false,
            payMoneyMsg:false,
            flagDownload:false,
        }
    }
    getCancel(e){
        e.nativeEvent.stopImmediatePropagation();
        this.setState({
            payProblemFlag:!this.state.payProblemFlag
        })
    }
    getPayCancel(e){
        e.nativeEvent.stopImmediatePropagation();
        this.setState({
            payOrderMoneyFlag:false
        })
        setWechatTimer = setInterval(() => {
            var params = {
                serId:this.state.serId
            }
            React.$http.paperCheckDetailInfo(params).then((res)=>{
                if(res&&res.success){
                    this.setState({
                        paperCheckInfo:res.paperCheckInfo
                    })
                    if(res.paperCheckInfo.result_pdf){
                        this.setState({
                            flagDownload:true
                        })
                        clearInterval(setWechatTimer)
                    }
                }
            })
        },2000);
        // this.getOrderInfo(this.state.serId)
        // setloadTimer = setInterval(()=>{
        //     this.setState({
        //         flagDownload:true
        //     })
        // },5000)
    }
    
    // 点击 我已完成支付按钮 支付遇到了问题（检测支付是否成功）
    getPayOrder(e){
        e.nativeEvent.stopImmediatePropagation();
        axios({
            method: 'post',
            url: requestMainUrl + 'wx/orderQuery/'+this.state.orderNO+'/2',
        }).then(res => {   
            if(res&&res.data){ 
                if(res.data.status){
                    this.setState({
                        payOrderMoneyFlag:!this.state.payOrderMoneyFlag,
                        payMoneyMsg:res.data.status
                    })
                }else{
                    this.setState({
                        payProblemFlag:!this.state.payProblemFlag,
                    })
                }                
            }
        });
    }
    
    // 轮训支付成功或失败接口
    getEachPayInfo=()=>{
        var params = {
            serId:this.state.serId
        }
        React.$http.paperCheckDetailInfo(params).then((res)=>{
            if(res&&res.success){
                this.setState({
                    paperCheckInfo:res.paperCheckInfo
                })
                if(res.paperCheckInfo.result_pdf){
                    this.setState({
                        flagDownload:true
                    })
                }
                if(res.paperCheckInfo&&res.paperCheckInfo.pay_status===1){
                    this.setState({
                        payOrderMoneyFlag:true,
                        payMoneyMsg:true,
                    })
                    clearInterval(setWechatTimer);
                }
            }
        })
    }
    // 保存到本地并自动点击
    saveAs(data, name) {
        const urlObject = window.URL || window.webkitURL || window;
        const export_blob = new Blob([data]);
        const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
        save_link.href = urlObject.createObjectURL(export_blob);
        save_link.download = name;
        save_link.click();
    }
    // 下载含有url的文件
    downloadUrlFile(url, fileName) {
        const url2 = url.replace(/\\/g, '/');
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url2, true);
        xhr.responseType = 'blob';
        //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
        // 为了避免大文件影响用户体验，建议加loading
        xhr.onload = () => {
            if (xhr.status === 200) {
                // 获取文件blob数据并保存
                this.saveAs(xhr.response, fileName);
            }
        };
        xhr.send();
    }
    // 下载报告
    getOrderResultDown=(item)=>{
        // console.log(item)
        // var load_down = config.pathConUrl+config.urlMap.getCheckResultPdf+'?serId='+item.ser_id;
        var load_down = requestMainUrl+item.result_pdf;
        // console.log(load_down)
        this.downloadUrlFile(load_down,item.result_pdf)
    }
    
    getCountTime(){
        var minute = this.state.minute-this.state.paperCheckInfo.orderTimeM;
        var second = this.state.seconds-this.state.paperCheckInfo.orderTimeS;
        if(minute>0){
            this.setState({
                minute:minute,
                seconds:second
            })
        }else{
            this.setState({
                minute:0,
                seconds:0,
            })
        }
        setTimer = setInterval(()=>{
            if(minute>=0){
                if(second===0) {
                    minute-=1;
                    this.setState({
                        minute:minute
                    })
                    second = 59;
                    this.setState({
                        seconds:second
                    })
                } else {
                    // if(second<10){
                    //     this.setState({
                    //         second:'0'+second
                    //     })
                    // }
                    second -= 1;
                    this.setState({
                        seconds:second
                    })
                }
                if(minute===0&&second===0){
                    //倒计时30分钟结束后执行接口，关闭订单状态
                    this.getOverOrderChange();
                    clearInterval(setTimer);
                    clearInterval(setWechatTimer);
                }
                // else if(minute>=0&&second>0){
                //     //轮询订单状态是否改变
                //     this.getEachPayInfo()
                //     // setWechatTimer = setInterval(() => {
                //     // this.getEachPayInfo()
                //     // }, 2000);
                // }
            }
        },1000);
        return () => {
            clearInterval(setTimer);
        };
    }
    // 30分钟执行完毕后自动关闭订单状态
    getOverOrderChange(){
        React.$http.paperCheckfaildPaperCheck({
            serId:this.state.serId
        }).then((res)=>{
            if(res&&res.success){
                this.setState({
                    payOrderTimeFlag:!this.state.payOrderTimeFlag
                })
                clearInterval(setWechatTimer);              
            }
        })
    }
    getOrderCancel(){        
        this.setState({
            payOrderTimeFlag:!this.state.payOrderTimeFlag
        })
        this.getOrderInfo(this.state.serId)
    }
    getHide=()=>{
        this.setState({
            payProblemFlag:false,
            payOrderMoneyFlag:false,
        })
        /* if(this.state.payOrderTimeFlag){
            this.getEachPayInfo()
            this.setState({
                payOrderTimeFlag:false,
            })
        } */
    }
    // 根据订单号生成二维码链接地址
    getOrderDetail=(order)=>{
        axios({
            method: 'post',
            url: requestMainUrl + 'wx/unifiedorder/'+order+'/2/NATIVE?sid='+sid,
        }).then(res => {            
            if(res&&res.data){ 
                if(res.data.status){
                    this.setState({
                        chartQRCodeLink:res.data.codeUrl
                    })                    
                }else{
                    messageTips(res.data&&res.data.message,1)
                    return
                }
            }
        });
    }
    // 获取订单详情信息
    getOrderInfo(serId){
        React.$http.paperCheckDetailInfo({
            serId:serId
        }).then((res)=>{
            if(res&&res.success){
                this.setState({
                    paperCheckInfo:res&&res.paperCheckInfo,
                    orderNO:res&&res.paperCheckInfo&&res.paperCheckInfo.orderNo,                        
                })
                if(res.paperCheckInfo&&res.paperCheckInfo.result_pdf){
                    this.setState({
                        flagDownload:true
                    })
                }
                if(res.paperCheckInfo&&res.paperCheckInfo.ser_status===1){
                    this.getOrderDetail(res&&res.paperCheckInfo&&res.paperCheckInfo.orderNo);
                    this.getCountTime();
                    setWechatTimer = setInterval(() => {
                        this.getEachPayInfo()
                    },3000);
                }
            }else{
                messageTips(res&&res.message,1)
                return
            }
        })
    }
    getForm(){
        let arr = this.state.paperCheckInfo.goods_name.split('-')[0];
        let nums = ''
        if(arr==='本科版论文查重'){
            nums = '05'
        }else if(arr==='硕博版论文查重'){
            nums = '03'
        }else if(arr==='职称版论文查重'){
            nums = '04'
        }else if(arr==='通用版论文查重'){
            nums = '06'
        }
        window.location.href = '/checkpaper.html#/index/from/'+nums+'/'+arr
    }
    componentDidMount(){
        document.onclick = this.getHide;
        var serId = this.props.match.params.serId;
        this.setState({
            serId:serId,
        })
        if(sid&&serId){
            this.getOrderInfo(serId)
        }else{
            window.location.href = '/checkpaper.html'
        }
    }
    componentWillUnmount() {
        clearInterval(timer);
        clearInterval(setWechatTimer);
        clearInterval(setTimer);
        clearInterval(setloadTimer);
        this.setState = (state, callback) => {
            return;
        };
    }
    render(){
        const {
            payProblemFlag,
            paperCheckInfo,
            chartQRCodeLink,
            payMoneyMsg,
            payOrderMoneyFlag,
            minute,
            seconds,
            payOrderTimeFlag,
            flagDownload,
        }=this.state;
        return(
            <div className="containers">
                <Header></Header>
                <div className="mains">
                    <div className="wrapOrder">
                        <div className="detailTitle">
                            {
                                paperCheckInfo&&paperCheckInfo.ser_status===1?
                                (
                                    <div className="orderTitle">
                                        <div className="orderNum">
                                            <div className="orderOption">
                                                <div className="orderState">
                                                    <i className="icon ordersubmit"></i>订单提交成功
                                                </div>
                                                <div className="ordertext">
                                                    请您尽快付款！ 请您在
                                                    <i className="icon orderTime"></i>
                                                    {/* <CountDown minute={minute} seconds={second} /> */}
                                                    {/* <span className="timeNumber"><CountDown minute={(minute-paperCheckInfo.orderTimeM)>0?(minute-paperCheckInfo.orderTimeM):0} seconds={(second-paperCheckInfo.orderTimeS)>0?(second-paperCheckInfo.orderTimeS):0} /></span> */}
                                                    <span className="timeNumber">{minute<10?'0':''}{minute}:{seconds<10?'0':''}{seconds}</span>
                                                    {/* <span className="timeNumber">{minute}:{seconds}</span> */}
                                                    分钟内完成支付，超时订单会被自动关闭
                                                </div>
                                                <div className="ordertext">
                                                    订单号：{paperCheckInfo&&paperCheckInfo.orderNo}
                                                    <span className="marg">|</span>
                                                    请用微信扫描右侧二维码进行支付
                                                </div>
                                                <div className="order_btn">
                                                    <div className="orbtn orderbtn" onClick={(e)=>this.getPayOrder(e)}>我已完成支付</div>
                                                </div>
                                                <div className="borshow"></div>
                                            </div>
                                        </div>
                                        <div className="orderCode">
                                            <div className="ocodet">
                                                <div className="textfont">通过微信</div>
                                                <div className="textfont">扫描二维码支付</div>
                                                <div className="textfont mtop">应付金额</div>
                                                <div className="textMoney">¥{paperCheckInfo&&paperCheckInfo.user_cost}</div>
                                            </div>
                                            <div className="oqrcodet">
                                                <QRCode value={chartQRCodeLink} size={150} fgColor="#000000" />
                                            </div>
                                            <div className="clear"></div>
                                        </div>  
                                        <div className="clear"></div>                
                                    </div>
                                ):''
                            }
                            {/* 待付款 */}
                            
                            {/* 支付成功 */}
                            {/*
                                paySuccessFlag?
                                (
                                    <div className="orderTitle">
                                        <div className="orderNum">
                                            <div className="orderOption">
                                                <div className="orderState">
                                                    <i className="icon ordersuccess"></i>恭喜您，支付成功！
                                                </div>
                                                <div className="ordertext">系统正快马加鞭为您查询查重结果，请耐心等待！</div>
                                                <div className="ordertext">
                                                    订单号：{paperCheckInfo&&paperCheckInfo.orderNo}
                                                    <span className="marg">|</span>
                                                    您可以扫描右侧二维码关注知图公众号获取更多信息！
                                                </div>
                                                <div className="order_btn">
                                                    <a className="orbtn orderreturnbtn" href="/checkpaper.html#/order">返回我的查重</a>
                                                </div>
                                                <div className="borshow"></div>
                                            </div>
                                        </div>
                                        <div className="orderCode">
                                            <div className="ocodet">
                                                <div className="textfont">扫描二维码</div>
                                                <div className="textfont">关注知图公众号</div>
                                                <div className="textfont">获取更多信息</div>
                                            </div>
                                            <div className="oqrcodet">
                                                <img src="/assets/weChatCode.jpg" alt=""/>
                                            </div>
                                            <div className="clear"></div>
                                        </div>
                                        <div className="clear"></div>
                                    </div>
                                ):''*/
                            }
                            {
                                paperCheckInfo&&paperCheckInfo.ser_status===2?(
                                    <div className="orderTitle">
                                        <div className="orderState">
                                            <i className="icon ordersuccess"></i>订单已支付
                                        </div>
                                        <div className="ordertext">系统正快马加鞭为您查询查重结果，请耐心等待！</div>
                                        <div className="order_btn">
                                            <a className="orbtn orderreturnbtn" href="/checkpaper.html#/order">返回我的查重</a>
                                        </div>
                                    </div>
                                ):''
                            }
                            {/* 已完成 */}
                            {
                                paperCheckInfo&&(paperCheckInfo.ser_status===4||paperCheckInfo.ser_status===5)?
                                (
                                    <div className="orderTitle">
                                        <div className="orderState">
                                            <i className="icon ordersuccess"></i>订单已完成
                                        </div>
                                        {/* 检测报告已出，系统将会为您永久保存 */}
                                        <div className="ordertext">检测报告保留14天，请尽快下载报告到电脑永久保存！</div>
                                        <div className="order_btn">
                                            {
                                                flagDownload?(<div className="orbtn orderbtn" onClick={this.getOrderResultDown.bind(this,paperCheckInfo)}>下载报告</div>):'生成报告中...'
                                            }
                                            
                                        </div>
                                    </div>
                                ):''
                            }
                            {/* 已关闭 */}
                            {
                                paperCheckInfo&&(paperCheckInfo.ser_status>=7)?
                                (
                                    <div className="orderTitle">
                                        <div className="orderState">
                                            <i className="icon ordercolse"></i>订单已关闭
                                        </div>
                                        <div className="ordertext">{paperCheckInfo.ser_status===11?'逾期未完成支付操作，查重已关闭，您可以重新提交查重申请！':'您已取消订单，订单已关闭。'}</div>
                                        <div className="order_btn">
                                            {/* <a className="orbtn orderbtn" href="/checkpaper.html#/index">重新提交</a> */}
                                            <span className="orbtn orderbtn" onClick={this.getForm.bind(this)}>重新提交</span>
                                        </div>
                                    </div>
                                ):''
                            }
                        </div>
                        <div className="orderDetail">
                            <div className="boxDetail">
                                <div className="oerdertitle">订单详情</div>
                                <div className="orderDate">
                                    <span className="labeldata">订单编号</span>
                                    <span className="namedata">{paperCheckInfo&&paperCheckInfo.orderNo}</span>
                                </div>
                                <div className="orderDate">
                                    <span className="labeldata">下单时间</span>
                                    <span className="namedata">{paperCheckInfo&&paperCheckInfo.orderTime}</span>
                                </div>
                                <div className="orderDate">
                                    <span className="labeldata">论文标题</span>
                                    <span className="namedata">{paperCheckInfo&&paperCheckInfo.title}</span>
                                </div>
                                <div className="orderDate">
                                    <span className="labeldata">查重版本</span>
                                    <span className="namedata">{paperCheckInfo&&paperCheckInfo.goods_name}</span>
                                </div>
                                <div className="orderDate">
                                    <span className="labeldata">订单金额</span>
                                    <span className="namedata">¥{paperCheckInfo&&paperCheckInfo.user_cost}</span>
                                </div>
                                <div className="orderDate">
                                    <span className="labeldata">订单状态</span>
                                    <span className="namedata">
                                    {
                                        paperCheckInfo&&paperCheckInfo.ser_status===4?'已完成':paperCheckInfo&&paperCheckInfo.statusName
                                    }
                                        {/* {paperCheckInfo&&paperCheckInfo.statusName} */}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="wrapout" style={{display:payProblemFlag?'block':'none'}}>
                            <div className="weinner">
                                <div className="whead_top">
                                    <i className="icon_hg ico-type1"></i>支付遇到问题
                                </div>
                                <div className="wTcontent">支付尚未完成，请重新支付！</div>
                                <div className="wbtn">
                                    <span className="webtn comfir" onClick={(e)=>this.getCancel(e)}>确定</span>
                                </div>
                            </div>
                        </div>
                        
                        <div className="wrapout" style={{display:payOrderMoneyFlag?'block':'none'}}>
                            <div className="payinner">
                                <div className="payHead">
                                    <span className={`ico_paper ${payMoneyMsg?'pay_success':'pay_fail'}`}></span>
                                </div>
                                <div className="payTcontent">
                                    {payMoneyMsg?'恭喜您，您已经支付成功！':'支付失败，请重新支付'}
                                </div>
                                <div className="paybtn">
                                    <span className="comfirbtn" onClick={(e)=>this.getPayCancel(e)}>确定</span>
                                </div>
                            </div>
                        </div>
                        <div className="wrapout" style={{display:payOrderTimeFlag?'block':'none'}}>
                            <div className="payinner">
                                <div className="payHead">
                                    <span className={`ico_paper pay_fail`}></span>
                                </div>
                                <div className="payTcontent">
                                    逾期未支付，该订单即将关闭！
                                </div>
                                <div className="paybtn">
                                    <span className="comfirbtn" onClick={(e)=>this.getOrderCancel(e)}>确定</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer></Footer>
            </div>
            
        )
    }
}
